import { clsx } from "clsx";

interface CardLinkArrowProps {
  className?: string;
}

/**
 * Arrow icon that appears on hover for card links.
 * Must be used inside an element with `tw-group` class for hover detection.
 */
export function CardLinkArrow({ className }: CardLinkArrowProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={clsx("tw-opacity-0 tw-transition-opacity tw-duration-200 group-hover:tw-opacity-100", className)}
      aria-hidden
    >
      <path
        d='M12 10V4H6M4.16667 11.8333L11.3333 4.66667'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
